import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Card as BaseCard } from '@leroy-merlin-br/backyard-react-ui'

export const cardStyles = ({ theme }) => css`
  label: filters__card;

  ${theme.media.mega} {
    padding: ${theme.spacings.mega} 0;
  }

  & > div {
    padding: 0 ${theme.spacings.mega};
    overflow-y: hidden;
  }
`

export const Card = styled(BaseCard)(cardStyles)
